/* eslint-disable react/no-danger */
import PropTypes from "prop-types";
import Head from "next/head";
import { APP_ID } from "../../common/constants";
import { buildFileSrc } from "../../lib/helpers";
import config from "../../common/config";

const SEO = ({
  title,
  description,
  canonical,
  css,
  js,
  image,
  structuredData,
  metas,
  keywords,
  preLoads,
}) => {
  const renderMetas = () =>
    metas.map(({ name, property, content }) => (
      <meta
        key={`${name}-${property}`}
        name={name}
        property={property}
        content={content}
      />
    ));

  return (
    <Head>
      <title>{title}</title>
      <link rel="dns-prefetch" href={config.ASSETS_BASE_URL} />
      <link rel="dns-prefetch" href={config.IMAGES_BASE_URL} />
      <meta name="description" content={description} />
      <meta
        name="viewport"
        content="width=device-width,maximum-scale=5,initial-scale=1"
      />
      <meta property="og:type" content="article" />
      <meta property="og:locale" content="ar_SA" />
      <meta name="og:title" property="og:title" content={title} />
      <meta
        name="og:description"
        property="og:description"
        content={description}
      />
      <meta property="og:url" content={canonical} />
      {/* <meta property="og:site_name" content="Proper Noun" /> */}
      <meta name="twitter:card" content="app" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description?.trim()} />
      <meta name="twitter:site" content="@aqarapp" />
      <meta name="twitter:app:country" content="SA" />
      <meta name="twitter:app:name:iphone" content="عقار" />
      <meta name="twitter:app:id:iphone" content={APP_ID} />
      {/* <meta name="twitter:creator" content="@propernounco" /> */}
      {css && <link rel="stylesheet" href={css} />}
      {image && <meta property="og:image" content={image} />}
      {image && <meta name="twitter:image" content={image} />}
      {keywords && <meta name="keywords" content={keywords?.trim()} />}
      {canonical && <link rel="canonical" href={canonical} />}
      {metas.length && renderMetas()}
      {js && <script type="text/javascript" src={js} />}
      {structuredData && (
        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{ __html: structuredData }}
        />
      )}
      {preLoads.map((img) => (
        <link key={img} rel="preload" href={buildFileSrc(img)} as="image" />
      ))}
      <meta name="robots" content="index, follow" />
      <meta httpEquiv="Accept-CH" content="DPR, Viewport-Width" />
      <meta httpEquiv="Content-Type" content="text/html; charset=utf-8" />
      <meta name="language" content="Arabic" />
    </Head>
  );
};

SEO.propTypes = {
  title: PropTypes.string,
  description: PropTypes.string,
  canonical: PropTypes.string,
  css: PropTypes.string,
  js: PropTypes.string,
  image: PropTypes.string,
  structuredData: PropTypes.string,
  metas: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string,
      property: PropTypes.string,
      content: PropTypes.string,
    }),
  ),
  keywords: PropTypes.string,
  preLoads: PropTypes.arrayOf(PropTypes.string),
};

SEO.defaultProps = {
  title: "",
  description: "",
  canonical: "",
  css: "",
  js: "",
  image: "",
  structuredData: "",
  metas: [],
  keywords: "",
  preLoads: [],
};

export default SEO;
